module.exports = __webpack_public_path__ + "img/mazatlan_home_banner_4.66ba9249.jpeg";